module.exports = __webpack_public_path__ + "img/19.bc47be4b.jpg";